import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-hidden"
export default class extends Controller {
  static targets = ["trigger", "node"]

  toggleVisibility() {
    this.nodeTargets.forEach(node => node.classList.toggle("hidden"))
  }

  toggle(event) {
    const trigger = event.target
    const triggerIndex = this.triggerTargets.indexOf(trigger)

    this.nodeTargets.forEach(node => {
      const nodeIndex = this.nodeTargets.indexOf(node)
      if (nodeIndex === triggerIndex) {
        node.classList.remove("hidden")
      } else {
        node.classList.add("hidden")
      }
    })
  }

  makeVisible() {
    this.nodeTargets.forEach(node => {
      node.classList.remove("hidden")
    })
  }
}
